// TODO: css
import "./css/glpartneragreement_custom.css";

// Basic Style
import "./css/bootstrap.min.css";
import "./css/beyond.min.css";



// WEBPACK FOOTER //
// ./src/assets/base.js